// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3YtEw","rootSuccess":"CompleteLink_rootSuccess__zjlfb","rootFailure":"CompleteLink_rootFailure__1SjI-","isDisabled":"CompleteLink_isDisabled__sUwzv"};